import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import classNames from 'classnames';
import { stringify } from 'querystring';

import { ERefsApps } from '@enums';

import { ITranslatable, Translate, TranslateFn } from '@decorators';

import { AppInstalls, ButtonDefault, Rating } from '@components';

import { IAppHeaderProps } from './types';

import * as s from './AppHeader.scss';

@Translate('components.AppSeoPage.AppHeader')
export class AppHeaderComponent extends React.Component<IAppHeaderProps & RouteComponentProps> implements ITranslatable {

	declare t: TranslateFn;

	onLaunchButtonClick = () => {
		const loginQuery = {
			'app_id': this.props.appId,
			'page': `${location.origin}${this.props.location.pathname}`,
			'ref': ERefsApps.SEO_GAMES,
		};

		window.location.href = `${window.location.origin}?${stringify(loginQuery)}`;
	};

	render() {
		const {
			className,
			title,
			rating,
			voters,
			installs,
			isFake,
			onLaunchButtonClick,
		} = this.props;

		return (
			<div className={classNames(className, s.block, { [s.blockFake]: isFake })}>
				<div className={s.info}>
					<h1 className={s.title}>{title}</h1>
					<div className={s.statWrapper}>
						<Rating className={s.statRating} rating={rating} voters={voters}/>
						<AppInstalls className={s.statInstalls} installs={installs}/>
					</div>
				</div>
				<div className={s.buttonWrapper}>
					<ButtonDefault
						className={s.button}
						isFullWidth
						onClick={onLaunchButtonClick}
					>
						{this.t('launch')}
					</ButtonDefault>
				</div>
			</div>
		);
	}

}

export const AppHeader = withRouter(AppHeaderComponent);
